/**
 * Labstep
 *
 * @module components/ProtocolCollection/Action/CreateTemplate
 * @desc Create Template Action for protocol collection
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import type React from 'react';

export const ProtocolCollectionActionCreateTemplate: React.FC =
  () => (
    <EntityActionCreate
      customActionName="New Template"
      body={{ is_template: true }}
      entityName="protocol_collection"
      redirectRoute={({ response }) => ({
        to: 'protocol_collection_show',
        params: { id: response.result },
      })}
      actionComponentProps={{
        type: 'button',
      }}
    />
  );
